<template>
  <Modal
    ref="resetPasswordModalRef"
    @onPositiveActionClick="closeDeleteSubAccountModal"
    positiveActionText="Tamam"
    title="Şifre gönderildi."
    class="deleteProductModal"
    type="success"
  >
    <template v-slot:body>
      <p class="modal-text">Alt hesap kullanıcısına ait telefon numarasına<br />
SMS ile yeni bir şifre gönderdik.</p>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { Modal } from "@n11/so-ui-components";

const resetPasswordModalRef = ref();

const openResetPasswordModal = () => resetPasswordModalRef?.value?.openModal();
const closeDeleteSubAccountModal = () => resetPasswordModalRef?.value?.hiddenModal();

defineExpose({
  openResetPasswordModal,
})

</script>

<style lang="scss" scoped>
.modal-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.05px;
}
</style>
